export const GET_CMS_CONTACTENOS = "GET_CMS_CONTACTENOS";
